import { COUNTRY } from '../../actions/action_types';

export const setCountry = (data) => (dispatch) => {
  dispatch({ type: COUNTRY, payload: data })
};